// extracted by mini-css-extract-plugin
export default {"title":"CatalogPageLayout_title__EBhht"};